import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { DemoBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import { Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { IFuelAuthorizedDrawerGroup } from 'types/fuelOps.interface'
import {
    FUEL_AUTHORIZED_DRAWERS,
    FUEL_AUTHORIZED_DRAWERS_CAPTION,
} from 'pages/FuelManagement/fuelOpsDemoData'
import {
    DrawerChip,
    DrawerChips,
    DrawerClassName,
    DrawerGroupRow,
    DrawerMeta,
} from './AuthorizedDrawersPanel.styled'

export const AuthorizedDrawersPanel = () => {
    const groups: IFuelAuthorizedDrawerGroup[] = FUEL_AUTHORIZED_DRAWERS
    return (
        <Container>
            <ContainerHeader>
                <Flex center gap='0.75rem'>
                    <TitleText>Authorized drawers</TitleText>
                    {groups.length > 0 && <DemoBadge />}
                </Flex>
            </ContainerHeader>
            <ContainerContent>
                <OtherText grey>{FUEL_AUTHORIZED_DRAWERS_CAPTION}</OtherText>
                {!groups.length ? (
                    <Flex mt='8'>
                        <OtherText grey>Authorized drawer lists appear once fuel custody roles are connected.</OtherText>
                    </Flex>
                ) : (
                    groups.map((group) => (
                        <DrawerGroupRow key={group.machineClass}>
                            <DrawerClassName>{group.machineClass}</DrawerClassName>
                            <DrawerChips>
                                {group.drawers.map((drawer) => (
                                    <DrawerChip key={drawer}>{drawer}</DrawerChip>
                                ))}
                            </DrawerChips>
                            <DrawerMeta>{group.updatedLabel}</DrawerMeta>
                        </DrawerGroupRow>
                    ))
                )}
            </ContainerContent>
        </Container>
    )
}
